import {
    CLAUSE_COLLECTION_NAME,
    COVERAGE_COLLECTION_NAME,
    SECTION_COLLECTION_NAME,
    SUBSECTION_COLLECTION_NAME,
    TRANSLATIONS_COLLECTION_NAME,
} from 'models';
import { useCollectionContext } from './collectionContext';

interface CompletionProp {
    complete: number;
    total: number;
    barWidth: string;
}
export const Completion = ({ complete, total, barWidth }: CompletionProp) => {
    const percentage = Math.round((100 * complete) / total) || 0;
    return (
        <div
            style={{
                flexGrow: 1,
                display: 'flex',
                marginRight: '16px',
                width: '100%',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <div style={{ width: barWidth, position: 'relative', marginRight: '5px' }}>
                    <div
                        style={{
                            width: barWidth,
                            backgroundColor: '#D8D8D8',
                            borderRadius: '4px',
                            height: '11px',
                        }}
                    ></div>
                    <div
                        style={{
                            width: `${percentage}%`,
                            position: 'absolute',
                            backgroundColor: '#18A0FB',
                            borderRadius: '4px',
                            height: '11px',
                            marginTop: '-11px',
                            transition: 'all 0.45s',
                        }}
                    ></div>
                </div>
                <div
                    style={{
                        width: '35px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    {percentage}%
                </div>
            </div>
        </div>
    );
};

export const LanguageCompletion = ({ languageIndexId }: { languageIndexId: string }) => {
    const [sections] = useCollectionContext(SECTION_COLLECTION_NAME);
    const [subsections] = useCollectionContext(SUBSECTION_COLLECTION_NAME);
    const [coverages] = useCollectionContext(COVERAGE_COLLECTION_NAME);
    const [clauses] = useCollectionContext(CLAUSE_COLLECTION_NAME);
    const [, , , translationsMap] = useCollectionContext(TRANSLATIONS_COLLECTION_NAME);
    const targetIds = sections
        ?.map((r) => r.id)
        .concat(subsections?.map((r) => r.id))
        .concat(coverages?.map((r) => r.id))
        .concat(clauses?.map((r) => r.id));
    const total = targetIds.length;
    const complete = targetIds
        .map((targetId) => !!translationsMap.get(`${languageIndexId}-${targetId}`)?.content)
        .filter((i) => i).length;
    return <Completion total={total} complete={complete} barWidth="80px" />;
};
